import React, { useRef, useState } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Center,
  FormControl,
  FormHelperText,
  Input,
  InputGroup,
  InputRightElement,
  VStack,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import TradingSpinner from "../TradingSpinner";

const PasswordField = ({ label, value, onChange }) => {
  const [show, setShow] = useState(false);
  return (
    <FormControl>
      <FormHelperText mb={1} ml={1}>{label} *</FormHelperText>
      <InputGroup size="sm">
        <Input
          type={show ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        <InputRightElement width="4.5rem">
          <Button variant="ghost" size="sm" onClick={() => setShow((s) => !s)}>
            {show ? <ViewIcon /> : <ViewOffIcon />}
          </Button>
        </InputRightElement>
      </InputGroup>
    </FormControl>
  );
};

const ChangePasswordDialog = ({
  isOpen,
  isLoading,
  curr_pass,
  setCurrPass,
  new_pass_1,
  setNewPass1,
  new_pass_2,
  setNewPass2,
  onCancel,
  onConfirm,
  onClose,
}) => {
  const cancelRef = useRef();

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered={true}
      closeOnOverlayClick={false}
    >
      {isLoading ? (
        <AlertDialogOverlay>
          <AlertDialogContent>
            <Center p={6}>
              <TradingSpinner size="40px" />
            </Center>
          </AlertDialogContent>
        </AlertDialogOverlay>
      ) : (
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold" pb={1}>
              Change Password
            </AlertDialogHeader>
            <AlertDialogBody pt={1}>
              <VStack spacing={2} align="stretch">
                <PasswordField
                  label="Current Password"
                  value={curr_pass}
                  onChange={setCurrPass}
                />
                <PasswordField
                  label="New Password"
                  value={new_pass_1}
                  onChange={setNewPass1}
                />
                <PasswordField
                  label="Confirm New Password"
                  value={new_pass_2}
                  onChange={setNewPass2}
                />
              </VStack>
            </AlertDialogBody>
            <AlertDialogFooter paddingTop={4}>
              <Button ref={cancelRef} borderRadius="md" onClick={onCancel}>
                Cancel
              </Button>
              <Button
                colorScheme="blue"
                borderRadius="md"
                onClick={onConfirm}
                ml={3}
              >
                Change Password
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      )}
    </AlertDialog>
  );
};

export default ChangePasswordDialog;
